import {
  FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_REQUEST,
  FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_SUCCESS,
  FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_FALUIRE,
} from './restoreDeletedProjectTemplateTypes'

const initialState = {
  loading: false,
  restoreProjectTemplateTaskForProjectPage: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_SUCCESS : return {
      ...state,
      allDeletedProjectTemplateTaskForProjectPage: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_RESTORE_DELETED_TEMPLATE_TASK_FOR_PROJECT_PAGE_FALUIRE : return {
      ...state,
      loading: false,
      allDeletedProjectTemplateTaskForProjectPage: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
